module.exports = __webpack_public_path__ + "media/charte_selection/arrow1-9b5b8af0.png";